import { FC } from 'react';

import { Dropdown, DropdownItem } from '@base-app';
import { Body, CardContainer, Content, Header, Icon, InfoPanel, Separator, Title } from './CardGrid.style';
import { CardGridProps, Direction } from './CardGrid.types';
import { Sizes } from '@/common/types';

const CardGrid: FC<CardGridProps> = ({
  children,
  css,
  infoPanel,
  isReverse,
  direction,
  handleClick,
  headerOptions,
  title,
}) => {
  const handleSelect = (item: DropdownItem): void => {
    handleClick?.(item);
  };

  const getFlexDirection = (): string => {
    let flexDirection = '';

    if (isReverse !== undefined && isReverse) {
      flexDirection = direction === undefined || direction === Direction.COLUMN ? 'row-reverse' : 'column-reverse';
    }

    return flexDirection;
  };

  return (
    <CardContainer data-testid="card-grid" css={css}>
      {(title ?? headerOptions) && (
        <Header data-testid="card-grid-header">
          <Title data-testid="card-grid-title">{title}</Title>
          {headerOptions && headerOptions.length > 0 && (
            <Dropdown
              id="card-grid-options"
              icon={<Icon />}
              items={headerOptions}
              onSelect={handleSelect}
              size={Sizes.SMALL}
            />
          )}
        </Header>
      )}
      <Separator />
      <Body data-testid="card-grid-body" direction={direction} css={{ flexDirection: getFlexDirection() }}>
        {infoPanel !== undefined && (
          <InfoPanel direction={direction} isReverse={isReverse} role="child">
            {infoPanel}
          </InfoPanel>
        )}
        <Content
          role="child"
          css={{
            height: '100%',
            width: '100%',
          }}
        >
          {children}
        </Content>
      </Body>
    </CardContainer>
  );
};

export default CardGrid;
